export default "__VITE_ASSET__B35JHO8P__"